import { API_endpoints } from "../config";

export const getParentData = async (id = null): Promise<any> => {
    try {
        const body = id ? { id } : {};

        const response = await fetch(API_endpoints.getParentData, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(body),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Laden von parent Daten.");
        }
        return await response.json();
        
    } catch (error) {
        console.error("Fehler beim Laden parent von Daten:", error);
    }
};